import React, { useEffect } from 'react';
import { useMutation } from '@apollo/client';

import { BLANK_PAGE_ROUTE } from '@routes';
import { ClearQuickViewsDataTypeCacheForUserId } from '@resources/tests.graphql';

import V2SettingsIframe from '@aware/common/v2-settings-iframe';

const ApproveStudentAccessLists = () => {
  /**
   * This calls an API to remove the QuickViewsDataViews on the server side for a specific user (as opposed
   * to the currently logged in user), so no need to do anything with the cache here
   */
  const [clearDataViewsCacheForUserId] = useMutation(ClearQuickViewsDataTypeCacheForUserId);

  useEffect(() => {
    window.top.resetDataViewsCache = userId => {
      clearDataViewsCacheForUserId({ variables: { userId } });
    };

    return () => delete window.top.resetDataViewsCache;
  }, []);

  return (
    <V2SettingsIframe
      iframeSrc={`/aware/?embed=1&leftSrc=/webmanager/Roster/MonitorLists.aspx&detailsSrc=${BLANK_PAGE_ROUTE}`}
      title="Approve Student Access Lists"
    />
  );
};

export default ApproveStudentAccessLists;
